<template>
  <div class="bg">
    <div v-if="shipList.length > 0">
      <div
        :key="item.shipNum"
        v-for="item in shipList"
        @click="$router.push('/ship/shipDetail/' + item.id)"
        class="shipWrapper"
      >
        <div class="shipCode">
          <Icon class="iconShip" type="iconchuan"></Icon>
          <span class="shipCodeNum">{{ item.shipCode }}</span>
        </div>
        <div class="flex info">
          <div class="flex1 border-r">
            <div class="shipTitle">渔船主</div>
            <div class="shipContent">{{ item.shipowner }}</div>
          </div>
          <div class="flex1">
            <div class="shipTitle">共享人</div>
            <div class="shipContent">{{ item.clientCount }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading" v-if="loading">
      <img src="../../assets/loading.gif" />加载中
    </div>
    <div v-else>
      <div class="noMore" v-if="noMore">
        到底了~~
      </div>
      <div class="noMore" v-else @click="addMore">
        点击加载
      </div>
    </div>
    <div class="add" @click="$router.replace('/ship/addShip')">
      <img src="../../assets/add@2x.png" />
    </div>
  </div>
</template>

<script>
import { getShipList } from "../../api/ship";

export default {
  name: "shipList",
  data() {
    return {
      page: {
        page: 1,
        limit: 10
      },
      shipList: [],
      loading: true,
      noMore: false
    };
  },
  activated() {
    this.shipList = [];
    this.getShipList();
  },
  methods: {
    getShipList() {
      this.loading = true;
      getShipList(this.page)
        .then(res => {
          this.loading = false;
          this.shipList = this.shipList.concat(res.records);
          if (res.current >= res.pages) {
            this.noMore = true;
          } else {
            this.noMore = false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.noMore = false;
          this.$showError(err);
        });
    },
    addMore() {
      this.page.page += 1;
      this.getShipList();
    }
  }
};
</script>

<style scoped>
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.bg {
  overflow: hidden;
  font-size: 14px;
}
.shipImg img {
  width: 100%;
  height: 100%;
  display: block;
}
.noMore {
  text-align: center;
  padding: 30px 0;
}
.add {
  width: 90px;
  height: 90px;
  position: fixed;
  right: 60px;
  bottom: 60px;
  z-index: 1;
}
.add img {
  width: 100%;
  height: 100%;
}

.shipWrapper {
  margin: 30px;
  height: 200px;
  background: rgba(55, 146, 241, 1);
  border-radius: 12px;
  padding: 15px 25px;
}
.shipCode {
  padding: 15px 0;
  border-bottom: 1px solid #51a4fb;
}
.iconShip {
  color: #fff;
  font-size: 20px;
  line-height: 56px;
  margin-left: 13px;
  margin-right: 20px;
}
.shipCodeNum {
  font-size: 18px;
  font-weight: bold;
  line-height: 56px;
  color: #fff;
}
.info {
  padding: 20px 0;
  text-align: center;
}
.shipTitle {
  color: #a4cffb;
  font-size: 12px;
}
.shipContent {
  font-size: 14px;
  color: #fff;
}
.border-r {
  border-right: 1px solid #51a4fb;
}
.loading {
  padding: 30px 0;
  text-align: center;
}
.loading img {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}
</style>
